import { FC, HTMLAttributes } from 'react';

import styles from './SearchPanelTitle.module.css';

const SearchPanelTitle: FC<HTMLAttributes<HTMLDivElement> & { variant?: 'history'; title: string }> = ({
  title,
  variant,
  ...divProps
}) => {
  return (
    <div
      className={`${styles.searchPanelTitle} ${variant === 'history' ? styles.history : styles.regular}`}
      {...divProps}
    >
      {title}
    </div>
  );
};
export default SearchPanelTitle;
